import { selector } from 'recoil';
import { agentUserId } from '../atoms/agentUserId';
import { user } from '../atoms/user';
import { methodNameEnum, refetchToggle } from './makePHPRequest';
import {
  endpointEnum,
  makeAPIRequest,
} from '../../services/rest/makeAPIRequest';
export const getAgentVmDrop = selector({
  key: 'getAgentVmDrop',
  get: async ({ get }) => {
    try {
      const result = {};
      get(refetchToggle(endpointEnum.GET_VM_DROP));
      const User = get(agentUserId);
      const userAtom = get(user);
      if (userAtom.apikey && User.id) {
        const data = {
          call: methodNameEnum.GET_VM_DROP,
        };
        const { response } = get(
          makeAPIRequest({
            endpoint: endpointEnum.GET_VM_DROP,
            payloadJsonString: JSON.stringify(data),
          })
        );
        const filtered = response?.data?.result?.filter(
          (vm) => vm.userid === +User.id
        );
        result.filteredByAgent = filtered;
        return result;
      } else {
        return result;
      }
    } catch (error) {
      throw error;
    }
  },
});
